/**
 * Combined NAATI Q&A set (Wave 1 + extra + Wave 5), de-duplicated by slug.
 * Every /naati question surface (hub, /naati/q/$slug, sitemap, AI feeds)
 * reads from here so a new wave lands everywhere at once.
 */
import { NAATI_QA, type NaatiQA } from "./questions-500";
import { NAATI_QA_EXTRA } from "./questions-extra";
import { NAATI_QA_WAVE5 } from "./questions-wave5";
import { NAATI_QA_WAVE6 } from "./questions-wave6";
import { liftToFloor } from "../_qa/topup-merge";
import { NAATI_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: NaatiQA[] = [];
const seen = new Set<string>();
for (const qa of [...NAATI_QA, ...NAATI_QA_EXTRA, ...NAATI_QA_WAVE5, ...NAATI_QA_WAVE6]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<NaatiQA["cluster"], NaatiQA>(merged, {
  prefix: "naati-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 ข้อกำหนดของหน่วยงานปลายทางเปลี่ยนได้ ควรตรวจสอบหน้าเว็บทางการก่อนยื่น เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "หน่วยงานผู้รับเอกสารในออสเตรเลียหรือนิวซีแลนด์",
  clusterTh: "งานแปลรับรองโดยนักแปล NAATI",
  primary: NAATI_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "verify", location: "location" },
});

export const NAATI_QA_ALL: NaatiQA[] = merged;

export const NAATI_QA_ALL_BY_SLUG: Record<string, NaatiQA> = Object.fromEntries(
  NAATI_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const NAATI_QA_PHRASING_COUNT = NAATI_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
